import { pages } from '@app/util/links'
import { ProfileAvatar } from '@app/components/blocks/avatarStack/AvatarStack'
import { MunicipalityCard } from '@app/components/blocks/card/MunicipalityCard'
import { SearchGrid } from '@app/components/blocks/searchGrid/SearchGrid'
import { ReactNode } from 'react'

type MunicipalitySearchGridItem = {
  id: number
  slug: string
  avatar?: string
  title: string
  description?: string
  hasBadge?: boolean
  isLocked?: boolean
  plots?: number
  initiatives: number
  avatars: ProfileAvatar[]
}

export type MunicipalitySearchGridProps = {
  items: MunicipalitySearchGridItem[]
  totalItems: number
  title: string
  subtitle: string
  searchTerm?: string
  isLoading: boolean
  loadMore: () => void
  onResetSearch: () => void
  footer?: ReactNode
}

export const MunicipalitySearchGrid = (props: MunicipalitySearchGridProps) => {
  return (
    <SearchGrid
      {...props}
      items={props.items.map((i) =>
        renderCard(i, pages.municipalityPage(i.slug)),
      )}
      gridStyle={{
        display: 'grid',
        gridTemplateColumns: 'repeat(5, minmax(14rem, 1fr))',
        '@media (max-width: 1400px)': {
          gridTemplateColumns: 'repeat(4, minmax(14rem, 1fr))',
        },
        '@media (max-width: 1200px)': {
          gridTemplateColumns: 'repeat(3, minmax(14rem, 1fr))',
        },
        gap: '1rem',
      }}
    />
  )
}

const renderCard = (item: MunicipalitySearchGridItem, to: string) => {
  return <MunicipalityCard key={item.slug} to={to} {...item} />
}
